export const BusinessDirections = {
  en: {
    'Business Directions': 'Business Directions',
    'Create Business Direction': 'Create Business Direction',
    Code: 'Code',
    Color: 'Color',
  },
  uk: {
    'Business Directions': 'Напрямки діяльності',
    'Create Business Direction': 'Створити напрямок діяльності',
    Code: 'Код',
    Color: 'Колір',
  },
};

export const BusinessDirectionForm = {
  en: {
    ...BusinessDirections.en,
    'New Business Direction': 'New Business Direction',
    'Edit Business Direction': 'Edit Business Direction',
    'Update Business Direction': 'Update Business Direction',
    'Code Hint':
      'Lowercase latin letters, digits and underscores only. Auto-filled from the name.',
  },
  uk: {
    ...BusinessDirections.uk,
    'New Business Direction': 'Новий напрямок діяльності',
    'Edit Business Direction': 'Редагування напрямку діяльності',
    'Update Business Direction': 'Оновити напрямок діяльності',
    'Code Hint':
      'Лише малі латинські літери, цифри та підкреслення. Заповнюється з назви автоматично.',
  },
};
